/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Card, message } from "antd";
import { Collapse, Form, Flex, Row, Col, Space } from "antd";
import { Input, Button, Table, Typography, Select } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdGroupAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useAccessPageState from "../../../hooks/useAccessPageState";

// import dayjs from 'dayjs';
import CustomerService from "../../../service/ERP/Customer.service";

const customerservice = CustomerService();

const StatusDot = ({ color }) => (
  <span
    style={{
      display: "inline-block",
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: color,
      marginRight: 6,
      verticalAlign: "middle",
    }}
  />
);
/* ค่าเริ่มต้นแสดงเฉพาะที่เปิดใช้งาน — ที่ปิดแล้วต้องเลือกเองถึงจะเห็น */
const DEFAULT_STATUS = "active";

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const CustomersAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
      const runSearch = (v) => {
        saveState(v, paginationOverride ?? tablePagination);
        const data = { ...v };
        customerservice
          .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
          .then((res) => {
            const { data } = res.data;
  
            setAccessData(data);
          })
          .catch((err) => {
            console.log(err);
            message.error("Request error!");
          });
      };

      if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
        runSearch(forcedValues);
        return;
      }

      form.validateFields().then((v) => {
        runSearch(v);
      });
    };

  const handleClear = () => {
    clearState();
    form.resetFields();
    form.setFieldValue("active_status", DEFAULT_STATUS);

    const nextPagination = restoreDefaultPagination();

    handleSearch({ active_status: DEFAULT_STATUS }, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "สร้าง Delivery Note",
          action: "create",
        },
      },
    });
  };

  const handleEdit = (data) => {
    // setManageConfig({...manageConfig, title:"แก้ไข Sample Request", action:"edit", code:data?.srcode});
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "แก้ไข Delivery Note",
          action: "edit",
          code: data?.cuscode,
        },
      },
    });
  };

  const handleView = (data) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View ข้อมูลลูกค้า",
          action: "view",
          code: data?.cuscode,
        },
      },
    });
  };

  const getData = (data) => {
      customerservice
        .search(data)
        .then((res) => {
          const { data } = res.data;
  
          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

  useEffect(() => {
      const restored = restoreState();

      /* ถ้ายังไม่เคยเลือกสถานะไว้ ให้เริ่มที่ "เปิดใช้งาน" */
      const values = restored?.searchValues ?? {};
      if (!values.active_status) values.active_status = DEFAULT_STATUS;
      form.setFieldsValue(values);

      handleSearch(values, restored?.tablePagination);
    }, []);

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
              <Form
                form={form}
                layout="vertical"
                autoComplete="off"
                onValuesChange={() => {
                  handleSearch();
                }}
              >
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="รหัสลูกค้า." name="cuscode">
                      <Input placeholder="Enter Customer Code." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="ชื่อลูกค้า." name="cusname">
                      <Input placeholder="Enter SCustomer Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="ประเทศ." name="country">
                      <Input placeholder="Enter Countires." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="สถานะการใช้งาน" name="active_status">
                      <Select
                        onChange={() => handleSearch()}
                        options={[
                          { label: <span><StatusDot color="#52c41a" />เปิดใช้งาน</span>, value: "active" },
                          { label: <span><StatusDot color="#ff4d4f" />ปิดใช้งาน</span>, value: "inactive" },
                          { label: "ทั้งหมด", value: "all" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        Search
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        Clear
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
      // bordered={false}
    />
  );
  const column = accessColumn({ handleEdit, handleView });

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
          List of Customer
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdGroupAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            สร้างลูกค้า
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="customer-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="cuscode"
                columns={column}
                dataSource={accessData}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default CustomersAccess;
